import { TRANSLATION_KEYS as T } from "@cadenza/i18n-core";
import { useLanguageContext } from "@cadenza/i18n-react";

import {
  RoleIcon,
  StartRoleIcon,
  ActionIcon,
  TriggerIcon,
  CaseRefinementIcon,
  PartRefinementIcon,
  PartRepeatIcon,
  SpringIcon,
} from "@cadenza/icons";

/**
 * Hook that provides shape definitions with translated labels
 * @returns {Array} Array of shape definitions with localized labels
 */
export const useShapeDefinitions = () => {
  const { STRINGS = {} } = useLanguageContext() || {};
  const ROLE = STRINGS[T.ROLE] || "Role";
  const TRIGGER = STRINGS[T.TRIGGER] || "Trigger";
  const ACTION = STRINGS[T.ACTION] || "Action";
  const STARTROLE = STRINGS[T.STARTROLE] || "Start Role";
  const PARTREFINE = STRINGS[T.PARTREFINE] || "Part Refinement";
  const CASEREFINE = STRINGS[T.CASEREFINE] || "Case Refinement";
  const PARTREPEAT = STRINGS[T.PARTREPEAT] || "Part Repeat";
  const SPRING = STRINGS[T.SPRING] || "Spring";

  const shapeDefinitions = [
    {
      id: "role",
      type: "role",
      class: "role",
      labelKey: "ROLE",
      label: ROLE,
      icon: RoleIcon,
      width: 20,
      height: 30,
    },
    {
      id: "trigger",
      type: "trigger",
      class: "activity",
      labelKey: "TRIGGER",
      label: TRIGGER,
      icon: TriggerIcon,
      width: 20,
      height: 20,
    },
    {
      id: "action",
      type: "action",
      class: "activity",
      labelKey: "ACTION",
      label: ACTION,
      icon: ActionIcon,
      width: 20,
      height: 20,
    },
    {
      id: "start-role",
      type: "start-role",
      class: "activity",
      labelKey: "STARTROLE",
      label: STARTROLE,
      icon: StartRoleIcon,
      width: 20,
      height: 20,
    },
    {
      id: "case",
      type: "case",
      class: "refinement",
      labelKey: "CASEREFINE",
      label: CASEREFINE,
      icon: CaseRefinementIcon,
      width: 30,
      height: 25,
    },
    {
      id: "part",
      type: "part",
      class: "refinement",
      labelKey: "PARTREFINE",
      label: PARTREFINE,
      icon: PartRefinementIcon,
      width: 30,
      height: 25,
    },
    {
      id: "repeat",
      type: "repeat",
      class: "refinement",
      labelKey: "PARTREPEAT",
      label: PARTREPEAT,
      icon: PartRepeatIcon,
      width: 20,
      height: 20,
    },
    {
      id: "ellipsis",
      type: "ellipsis",
      class: "activity",
      labelKey: "SPRING",
      label: SPRING,
      icon: SpringIcon,
      width: 20,
      height: 20,
    },
  ];

  return shapeDefinitions;
};
